/// <reference path="../_all.ts" />

module glossar {

  ZoomDialogDirective.$inject = [
    '$mdDialog',];
  export function ZoomDialogDirective(
    $mdDialog: ng.material.IDialogService
  ): ng.IDirective {

    return {
      restrict: 'A',
      transclude: true,
      scope: {},
      link: function (scope: IZoomDialogDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, c : ng.IController, transclude: ng.ITranscludeFunction) {
        var content: JQuery = null;

        var toolbar: string = "<md-dialog class='zoomdialog'><md-toolbar class='zoom-dialog-toolbar'><div class='md-toolbar-tools'><span flex></span><md-button class='md-icon-button close' ng-click='close();' aria-label='Close'><svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='/res/svg/sprite.svg?[:$CacheVersion:]#plus'></use></svg></md-button></div></md-toolbar>";
        var containerleft: string = "<md-dialog-content><div ng-click='close()' class='zoom-content-container'>";
        var containerright: string = "</div></md-dialog-content></md-dialog>";

        transclude(scope, function (clone) {
          element.append(clone);
          element.find("img").addClass("zoomable");
        });

        element.on("click", (ev: JQueryEventObject) => {
          $mdDialog.show(<ng.material.IDialogOptions>{
            controller: () => { },
            scope: angular.extend(scope.$new(), {
              close: function () { $mdDialog.hide(); }
            }),
            template: toolbar  + containerleft + element.html() + containerright,
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: <any>ev,
            clickOutsideToClose: true,
            fullscreen: true, // Only for -xs, -sm breakpoints.
            locals: {
            },
          })
        });

      }
    }

  }

}